
import MembersCarousel from "../PageElements/AllMembersPageElements/MembersCarousel";
import ContactBGSection from "../PageElements/ContactPageElement/ContactBgSection";
import ContactInfoSection from "../PageElements/ContactPageElement/ContactInfoSection";
import ConsultSection from "../PageElements/HomePageElements/ConsultSection";
import ServiceSection from "../PageElements/HomePageElements/ServiceSection";
// import AllMembersFirstSection from "../PageElements/MemberPageFirstSection";

export default function AllMembersPage() {
    return (
        <>
     
              {/* <ContactBGSection/> */}
            {/* <ContactInfoSection/> */}
            {/* in use  */}
            {/* <AllMembersFirstSection /> */}
            {/* in use  */}

            {/* <AllMembersPageBody /> */}

            {/* in use  */}
            <MembersCarousel />
            <ConsultSection/>
            {/* in use  */}
             {/* <ServiceSection/> */}
        </>
    );
}